import axios from 'axios';

function authHeaders() {
  const token = localStorage.getItem('walmates-token');
  return { Authorization: `Bearer ${token}` };
}

function userId() {
  return localStorage.getItem('walmates-user_id');
}

function fileQueryParams(finfo, extra = {}) {
  const params = new URLSearchParams({
    user_id: userId(),
    file_id: String(finfo.id),
    ...extra,
  });
  if (finfo.vault_id != null) {
    params.set('vault_id', String(finfo.vault_id));
  }
  return params;
}

/**
 * Ask the server for a short-lived signed R2 GET URL.
 */
export async function getVaultAttachmentSignedUrl(finfo) {
  const params = fileQueryParams(finfo);

  const { data } = await axios.get(`/api/vault/downloadfile?${params}`, {
    headers: authHeaders(),
  });

  if (!data?.url) {
    throw new Error('No download URL returned');
  }
  return data.url;
}

/**
 * Fetch attachment bytes via the same-origin API (avoids R2 CORS).
 * Returns a Blob suitable for object URLs, download, print, and share.
 */
export async function fetchVaultAttachmentBlob(finfo, { disposition = 'inline' } = {}) {
  const params = fileQueryParams(finfo, { disposition });
  const res = await fetch(`/api/vault/file?${params}`, {
    headers: authHeaders(),
  });
  if (!res.ok) {
    let detail = '';
    try {
      const body = await res.json();
      detail = body?.error ? `: ${body.error}` : '';
    } catch {
      /* ignore */
    }
    throw new Error(`Failed to load file (${res.status})${detail}`);
  }
  return res.blob();
}

/**
 * Ask the server for a short-lived signed R2 GET URL, then open it.
 */
export async function openVaultAttachment(finfo) {
  const url = await getVaultAttachmentSignedUrl(finfo);
  const opened = window.open(url, '_blank');
  if (!opened) {
    throw new Error('Popup blocked');
  }
  return url;
}

/**
 * Upload via same-origin API (server writes to R2). Avoids R2 bucket CORS.
 * Returns `{ file_id }`.
 */
export async function uploadVaultAttachment(vault_id, selectedFile) {
  const uid = userId();
  const content_type = selectedFile.type || 'application/octet-stream';

  const form = new FormData();
  form.append('file', selectedFile);
  form.append('user_id', uid);
  form.append('vault_id', String(vault_id));
  form.append('file_name', selectedFile.name);
  form.append('content_type', content_type);

  const res = await fetch('/api/vault/upload-file', {
    method: 'POST',
    headers: authHeaders(),
    body: form,
  });

  let confirmed = null;
  try {
    confirmed = await res.json();
  } catch {
    /* ignore */
  }

  if (!res.ok) {
    throw new Error(confirmed?.error || `Upload failed (${res.status})`);
  }

  if (!confirmed?.file_id) {
    throw new Error(confirmed?.error || 'Upload failed');
  }

  return confirmed;
}
